"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrRequestsBlockerFactory = void 0;
const eventBussynchXhrBlockRequestInformant_1 = require("./eventBussynchXhrBlockRequestInformant");
const synchXhrBlockRequest_1 = require("./synchXhrBlockRequest");
const xhrRequestsBlocker_1 = require("./xhrRequestsBlocker");
class XhrRequestsBlockerFactory {
    static getNewEventBusSynchronizedXHRRequestsBlocker(eventBus) {
        const requestsBlocker = new xhrRequestsBlocker_1.XhrRequestsBlocker();
        const informant = new eventBussynchXhrBlockRequestInformant_1.EventBusSynchXhrBlockRequestInformant(requestsBlocker, eventBus);
        return new synchXhrBlockRequest_1.SynchronizedXHRRequestsBlocker(requestsBlocker, informant);
    }
    static getNewXHRRequestsBlocker() {
        return new xhrRequestsBlocker_1.XhrRequestsBlocker();
    }
}
exports.XhrRequestsBlockerFactory = XhrRequestsBlockerFactory;
//# sourceMappingURL=factory.js.map